export function epiResolveLanguage(): string {
    const language = document.documentElement.getAttribute('lang');
    return language != null ? language : 'nb-no';
}
